<div class="menu-top">
    <div class="logo-holder">
        <img
            *ngIf="domainClass === 'ys'"
            src="assets/images/chat/logo-image.svg" />
        <img
            *ngIf="domainClass === 'up'"
            src="assets/images/chat/logo-image-up.svg" />
    </div>
    <div class="chat-side-menu-switcher">
        <app-chat-type-switcher
            [type]="chatGroupLogicService.chatType"
            (switched)="typeSwitched($event)"></app-chat-type-switcher>
    </div>
</div>

<hr class="separator mb-4" />

<div class="search-holder">
    <app-chat-search-field></app-chat-search-field>
</div>

<div class="accordion-list-holder">
    <app-chat-accordion-list
        [groups]="chatGroupLogicService.activeSubgroups"
        [selectedChatId]="openedChat.id"
        [openedSubgroup]="openedSubgroup"
        (chatSelected)="selectChat($event)"></app-chat-accordion-list>
</div>

<hr class="separator" />

<div class="menu-toggle-section">
    <div
        class="new-chat-button-holder"
        mat-button
        [matMenuTriggerFor]="menu">
        <span>Create New</span>
        <svg-icon
            [svgClass]="'new-chat-button'"
            src="/assets/images/chat/icon-new-chat.svg"></svg-icon>
    </div>
</div>
<div
    class="archive-section"
    (click)="openArchive()">
    <svg-icon
        [svgClass]="'archive-section-icon'"
        src="/assets/images/chat/archive-box.svg"></svg-icon>
    <span class="archive-section-label">Chat Archive</span>
</div>

<!-- New Chat/Channel Popup Menu-->
<mat-menu
    #menu="matMenu"
    class="popup-simple-menu new-chat-popup">
    <button
        mat-menu-item
        (click)="openNewChat()">
        <img src="/assets/images/chat/messages-icon.svg" />
        <span>New Chat</span>
    </button>
    <button
        mat-menu-item
        (click)="openNewChannelDialog()">
        <img src="/assets/images/chat/channel-icon.svg" />
        <span>New Channel</span>
    </button>
</mat-menu>
